import styled from '@emotion/styled';
import { Text, Icon } from '@pairy/pds-react';

export const Ul = styled.ul`
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  padding: 0;
  border-radius: 8px;
  gap: 8px;
`;

export const NavButton = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.transparent};
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  gap: 8px;
  opacity: 0.5;

  transition: all 0.15s ease-in-out;

  &.active {
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
    opacity: 1;
  }

  &.disabled {
    background-color: ${({ theme }) => theme.colors.zinc_200};
    color: ${({ theme }) => theme.colors.zinc_400};
  }

  &:hover {
    opacity: 1;
  }
`;

export const A = styled.a`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.transparent};
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  gap: 8px;
  opacity: 0.5;

  transition: all 0.15s ease-in-out;

  &[data-state='active'] {
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

export const LinkIcon = styled(Icon)`
  opacity: inherit;
`;

export const Name = styled(Text)`
  opacity: inherit;
`;
